// extracted by mini-css-extract-plugin
export default {"tableColumnsWithButtons":"RoleItem_tableColumnsWithButtons__Mx0Vi","actionButtons":"RoleItem_actionButtons__tHd1U","tableRowTemplate":"RoleItem_tableRowTemplate__nMXGK"};